import React, { useEffect, useState } from "react"
import { get, post } from "../../utils/apiClient"
import toast from "react-hot-toast"
import Select from "react-select"

export default function RolePermissionsAssociation() {
  const [roles, setRoles] = useState([])
  const [selectedRole, setSelectedRole] = useState("MANAGER")
  const [templates, setTemplates] = useState({})
  const [rolePermissions, setRolePermissions] = useState({})
  const [allRoleWisePermissions, setAllRoleWisePermissions] = useState([])

  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)

  const fetchRolePermissions = async () => {
    try {
      const data = await get("/manage/default/role-permissions")
      setRoles(data?.roles?.filter((r) => r !== "IT") || [])
      setTemplates(data?.globalPermissionTemplate || {})
      setAllRoleWisePermissions(data?.defaultRoleWisePermissions || [])

      const rolePerm = data?.defaultRoleWisePermissions?.find(
        (rp) => rp.role === selectedRole,
      )
      setRolePermissions(rolePerm ? rolePerm?.permissions : {})
    } catch (error) {
      console.error("Failed to fetch permissions", error)
    }
  }

  const loadRolePermissions = async () => {
    setLoading(true)
    await fetchRolePermissions()
    setLoading(false)
  }

  useEffect(() => {
    loadRolePermissions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRoleChange = (role) => {
    //const role = e.target.value
    setSelectedRole(role)
    const rolePerm = allRoleWisePermissions.find((rp) => rp.role === role)
    setRolePermissions(rolePerm ? rolePerm.permissions : {})
  }

  // const handlePermissionToggle = (category, permKey) => {
  //   setRolePermissions((prev) => {
  //     const categoryPerms = new Set(prev[category] || [])
  //     if (categoryPerms.has(permKey)) {
  //       categoryPerms.delete(permKey)
  //     } else {
  //       categoryPerms.add(permKey)
  //     }
  //     return { ...prev, [category]: Array.from(categoryPerms) }
  //   })
  // }

  const handlePermissionToggle = (category, permKey) => {
    setRolePermissions((prev) => {
      const updated = { ...prev }
      const categoryPerms = new Set(updated[category] || [])

      // Toggle the clicked permission
      if (categoryPerms.has(permKey)) {
        categoryPerms.delete(permKey)

        // If FOLDER_BROWSE is being unchecked, also remove related folder perms
        if (permKey === "FOLDER_BROWSE") {
          updated.DELETE = (updated.DELETE || []).filter(
            (p) => p !== "FOLDER_DELETE",
          )
          updated.WRITE = (updated.WRITE || []).filter(
            (p) => !["FOLDER_RENAME", "FOLDER_CREATE"].includes(p),
          )
        }
      } else {
        categoryPerms.add(permKey)
      }

      updated[category] = Array.from(categoryPerms)
      return updated
    })
  }

  const handleSave = async () => {
    setActionLoading(true)
    try {
      await post("/manage/default/role-permissions", {
        role: selectedRole,
        permissions: rolePermissions,
      })

      toast.success(`Permissions saved successfully`)

      fetchRolePermissions()
      setActionLoading(false)
    } catch (error) {
      toast.error(error)
      setActionLoading(false)
    }
  }

  const optionRoles = roles.map((n) => ({ value: n, label: n }))

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <>
          {/* Role selector */}
          <div>
            {/* <label htmlFor="roleSelect">Role: </label> */}
            {/* <select
              id="roleSelect"
              value={selectedRole}
              onChange={handleRoleChange}
              className="select"
            >
              {roles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select> */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label htmlFor="fruit-select">Role:</label>
              <Select
                id="roleSelect"
                className="basic-single"
                classNamePrefix="select"
                value={optionRoles.find(
                  (option) => option.value === selectedRole,
                )}
                // onChange={handleRoleChange}
                onChange={(selectedOption) =>
                  handleRoleChange(selectedOption.value)
                }
                options={optionRoles}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: 0,
                    maxWidth: "200px",
                  }),
                }}
                // isSearchable
              />
            </div>
          </div>

          {/* Permission sections */}
          <div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
            {["READ", "DELETE", "WRITE"].map((category) => (
              <div
                className="permission-box"
                key={category}
                style={{ flex: 1 }}
              >
                <h3>{category}</h3>
                {templates[category] &&
                  Object.entries(templates[category]).map(
                    ([permKey, permDesc]) => {
                      const folderBrowseChecked =
                        rolePermissions.READ?.includes("FOLDER_BROWSE")
                      const shouldDisable =
                        !folderBrowseChecked &&
                        [
                          "FOLDER_DELETE",
                          "FOLDER_RENAME",
                          "FOLDER_CREATE",
                        ].includes(permKey)

                      return (
                        <div key={permKey}>
                          <label className={shouldDisable ? "locked" : ""}>
                            <input
                              type="checkbox"
                              checked={
                                rolePermissions[category]?.includes(permKey) ||
                                false
                              }
                              onChange={() =>
                                handlePermissionToggle(category, permKey)
                              }
                              disabled={shouldDisable}
                            />
                            {permDesc}
                          </label>
                        </div>
                      )
                    },
                  )}
              </div>
            ))}
          </div>

          {/* Save button */}
          <button
            className="faxes-button"
            onClick={handleSave}
            style={{ marginTop: "10px", marginLeft: "0px" }}
          >
            {!actionLoading ? `Save` : `Saving ...`}
          </button>
        </>
      )}
    </div>
  )
}
